const mediaItems = [
  {
    title: '2026 年度街舞大赛精彩集锦',
    desc: '汇聚全国顶尖舞者的燃炸舞台，创意编舞与高难度动作，每日大赛作品介绍必看内容。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20street%20dance%20performance%20with%20dramatic%20stage%20lighting%20in%20warm%20coral%20and%20amber%20tones%2C%20artistic%20motion%20blur%20effect%2C%20modern%20minimalist%20composition%2C%20abstract%20dancer%20silhouettes%20with%20flowing%20ribbons%20of%20colored%20light%2C%20editorial%20photography%20style%2C%20no%20text%2C%20no%20faces%2C%20clean%20elegant%20design&width=800&height=500&seq=media-card-daily-01&orientation=landscape',
    tag: '街舞',
    views: '12.8万',
  },
  {
    title: '原创音乐大赛冠军作品深度解析',
    desc: '从编曲到演绎，全方位解读获奖作品的创作过程，每日大赛类型中最受欢迎的音乐赛道。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20musical%20composition%20with%20flowing%20sound%20waves%20and%20warm%20golden%20light%2C%20artistic%20piano%20keys%20dissolving%20into%20abstract%20shapes%2C%20soft%20coral%20accents%2C%20modern%20minimalist%20style%2C%20sophisticated%20atmosphere%2C%20editorial%20quality%2C%20no%20text&width=800&height=500&seq=media-card-daily-02&orientation=landscape',
    tag: '音乐',
    views: '9.6万',
  },
  {
    title: '创意设计大赛获奖作品巡礼',
    desc: '平面、UI、工业设计多赛道作品汇总，每日大全为你精选最具创新力的设计大赛佳作。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20creative%20design%20composition%20with%20geometric%20shapes%20and%20gradient%20textures%20in%20warm%20amber%20and%20soft%20white%20tones%2C%20artistic%20color%20palette%20swatches%20floating%20elegantly%2C%20modern%20minimalist%20editorial%20style%2C%20clean%20sophisticated%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=media-card-daily-03&orientation=landscape',
    tag: '设计',
    views: '7.3万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛作品介绍精选，热门大赛视频内容一览
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-black/50 text-white backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次浏览</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}